export const minOdd = 2;

export const lastRoundValue = { value: 100 };
